import React from 'react'
import { useTranslation } from 'react-i18next'

import { DropdownValue, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import { EnergySourceOption } from '../../../../../../../@types/dropdown-types'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'
import MultiSelectDropdown from '../../../../../../common/inputs/multiSelectDropdown/MultiSelectDropdown'

type AdditionalEnergySourceProps = {
  wrapperClassName?: string
  showLabelWithTooltip?: boolean
}

export type EnergySourceFieldProps = FieldProps<ConstructionScreenValidationResult> & AdditionalEnergySourceProps

const EnergySourceField: React.FC<EnergySourceFieldProps> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = getDefaultClasses('left'),
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && (
        <LabelWithTooltip
          inputId='construction-energy-source'
          labelText={t('wizard.screen.construction.energySource')}
          tooltipContent={<PopoverContent translationKey='wizard.screen.construction.energySource.tooltip' />}
          showMandatory={false}
        />
      )}
      <MultiSelectDropdown
        id='construction-energy-source'
        label={showLabelWithTooltip ? '' : 'wizard.screen.construction.energySource'}
        labelClassName={'font-ellipsis'}
        name='constructionEnergySource'
        values={insertionData.constructionEnergySource?.map((source) => source as DropdownValue)}
        noInformation={EnergySourceOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.construction.energySourceTypes',
          options: Object.keys(EnergySourceOption),
        }}
        onChange={(values: DropdownValue[]) =>
          onChange({ screen: screenName, property: 'constructionEnergySource' }, values)
        }
        allowEmpty={true}
      />
    </div>
  )
}

export default EnergySourceField
